import type { ApiClient } from '@travel/api-client';
import { apiPath } from 'constants/api';

export const postInHouseToken = (http: ApiClient, fIdSession: string) =>
  http.post(apiPath.fetchToken.pathname, {
    ignoreCommonErrorHandler: true,
    headers: {
      fIdSession,
    },
  });

export const postLogout = (http: ApiClient) =>
  http.post(apiPath.logoutToken.pathname, {
    ignoreCommonErrorHandler: true,
  });

export const refreshToken = (http: ApiClient, fIdSession: string) =>
  http.get(apiPath.refreshToken.pathname, {
    ignoreCommonErrorHandler: true,
    withAuthCode: true,
    headers: {
      fIdSession,
    },
  });
